// let ticking = false;
import anime from "animejs"
import {showScrollToEnter, showSquare} from "../cursorhelper";

export default () => ({


    displayBoxes: true, scrollDown: 1, scrollUp: 1,
    inTransition: false, mobileTransitionFinished: false, userIsAt: 'top',


    init() {
        document.body.classList.add('is-on-homepage-top-section')
        showScrollToEnter();
        // setTimeout(() => {
        //     this.$refs.link.classList.add('opacity-0')
        // }, 1000)
    }, async onTouchStart(e) {

        if(e.target.id==="cookieNotice" || e.target.closest('#cookieNotice')){
            return;
        }


        if (this.mobileTransitionFinished) return;

        this.displayBoxes = true

        await anime({
            targets: [this.$refs.boxA, this.$refs.boxB, this.$refs.boxC],
            translateY: ['100vh', '0vh'],
            duration: 1000,
            delay: anime.stagger(500),
            easing: 'linear'
        }).finished;

        this.mobileTransitionFinished = true
        try {
            this.$refs.slider.classList.add('-ready')
            this.$refs.slider.classList.add('-show')
        } catch (e) {

        }
        this.$root.style.height = "100%"

    },

    onWheel(e) {
        //if(this.transitionCompleted) return;

        // Scrolling down
        if (Math.sign(e.deltaY) === 1 && this.userIsAt === 'top') {

            this.scrollUp = 1
            this.scrollDown += e.deltaY

            if (this.scrollDown > 300 && this.inTransition === false) {
                this.inTransition = true
                this.appear()
                this.userIsAt = "bottom";
                //this.transitionCompleted = true;
            }

            // Scrolling up
        } else if (Math.sign(e.deltaY) === -1 && this.userIsAt === 'bottom') {
            this.scrollDown = 1
            this.scrollUp += e.deltaY
            if (this.scrollUp < -9000 && this.inTransition === false) {
                this.inTransition = true
                this.disappear()
                this.userIsAt = "top";
            }
        }
    },

    async appear() {

        this.scrollUp = 1
        this.displayBoxes = true

        await anime({
            targets: [this.$refs.boxA, this.$refs.boxB, this.$refs.boxC],
            translateY: ['100vh', '0vh'],
            duration: 1000,
            delay: anime.stagger(500),
            easing: 'linear'
        }).finished;

        this.$refs.slider.classList.add('-ready')
        this.$refs.slider.classList.add('-show')
        this.inTransition = false

        document.body.classList.remove('is-on-homepage-top-section')
        showSquare();


    }, disappear() {

        if (this.mobileTransitionFinished) return;
        const cursors = document.querySelectorAll('.cursor');
        this.changeVideo()

        this.$refs.slider.classList.remove('-show')

        setTimeout(async () => {
            this.$refs.slider.classList.remove('-ready')
            await anime({
                targets: [this.$refs.boxA, this.$refs.boxB, this.$refs.boxC],
                translateY: ['0vh', '100vh'],
                duration: 1000,
                delay: anime.stagger(500),
                easing: 'linear'
            }).finished;
            this.$refs.boxA.classList.remove('-show')
            this.inTransition = false
            showScrollToEnter();
        }, 1000);
    },

    changeVideo() {
        this.$dispatch('change-video')
    }

})
